// NUXIL Laravel - Main JavaScript Entry
// プレーン JS で記述。ES6+ OK。IE サポートなし。

document.addEventListener('DOMContentLoaded', () => {
  initLightbox();
  initNav();
});

// ヘッダーのドロップダウン (予定 / マスター / アカウント) とスマホのハンバーガー。
// 2026-08-19 打合せ「上のメニューは5つぐらいに絞る」対応で追加。
function initNav() {
  const closeAll = (except) => {
    document.querySelectorAll('[data-dropdown]').forEach((d) => {
      if (d === except) return;
      d.querySelector('[data-dropdown-menu]')?.classList.add('hidden');
      d.querySelector('[data-dropdown-button]')?.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-dropdown-button]');
    const toggle = e.target.closest('[data-nav-toggle]');

    if (button) {
      const dropdown = button.closest('[data-dropdown]');
      const menu = dropdown.querySelector('[data-dropdown-menu]');
      const willOpen = menu.classList.contains('hidden');
      closeAll(dropdown);
      menu.classList.toggle('hidden', !willOpen);
      button.setAttribute('aria-expanded', String(willOpen));

      return;
    }

    if (toggle) {
      const mobile = document.getElementById('navMobile');
      if (!mobile) return;
      const willOpen = mobile.classList.contains('hidden');
      mobile.classList.toggle('hidden', !willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      closeAll();

      return;
    }

    // メニューの中身をクリックしたときは閉じない (リンク遷移はそのまま)
    if (!e.target.closest('[data-dropdown-menu]')) closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
}

// 画像ライトボックス: [data-lightbox] 要素クリックで拡大表示 (overlay はインラインstyleで描画)
function initLightbox() {
  let overlay = null;

  const close = () => {
    if (overlay) {
      overlay.remove();
      overlay = null;
      document.body.style.overflow = '';
    }
  };

  const open = (src) => {
    if (!src) return;
    overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:50;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.85);padding:1rem;cursor:zoom-out';
    const img = document.createElement('img');
    img.src = src;
    img.style.cssText = 'max-height:100%;max-width:100%;border-radius:8px;box-shadow:0 10px 40px rgba(0,0,0,.5)';
    overlay.appendChild(img);
    overlay.addEventListener('click', close);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-lightbox]');
    if (!trigger) return;
    e.preventDefault();
    open(trigger.getAttribute('href') || trigger.dataset.src);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}
